export const textToColor = (text: string, opacity?: number) => {
  let hash = 0;
  const defaultOpacityHex = "1388";

  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += ("00" + value.toString(16)).slice(-2);
  }

  // Add opacity to the color
  const opacityHex =
    opacity !== undefined
      ? Math.round(opacity * 100)
          .toString(16)
          .padStart(2, "0")
      : defaultOpacityHex;

  // color += opacityHex;

  return color;
};
